<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="700px" :close-on-click-modal="false">
        <div class="dialogContent" v-loading="loading">
            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="140px">
                <el-form-item label="类型" prop="type" style="display: flex;align-items: center;margin-left: 0px;" class="typeItems"> 
                    <div class="print_screen_boxP">
                        <p
                            v-for="(item,index) in screenList"
                            :key="index"
                            @click="getPrintScreen(index)"
                            :class="printScreenIndex == index ? 'screen_text' : ''">
                            {{ item.name }}
                        </p>
                    </div>
                </el-form-item>
                <el-form-item label="级别名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入级别名称" maxlength="10"></el-input>
                </el-form-item>
<!--                <el-form-item label="佣金比例" prop="commissionRate">-->
<!--                    <el-input v-model="form.commissionRate" placeholder="请输入佣金比例" ></el-input>-->
<!--                </el-form-item>-->
                <el-form-item label="模型数量" v-if="form.type == 'MODEL'" prop="modelNum">
                    <el-input v-model="form.modelNum" placeholder="请输入所需模型数量" onkeyup="value=value.replace(/[^\d]/g,'')"
                              maxlength="4"></el-input>
                </el-form-item>
                <el-form-item label="所需作品数量" v-if="form.type == 'GRAPHIC'" prop="modelNum2">
                    <el-input v-model="form.modelNum2" placeholder="请输入所需作品数量" onkeyup="value=value.replace(/[^\d]/g,'')"
                              maxlength="4"></el-input>
                </el-form-item>
                <el-form-item label="设计订单数量" prop="demandNum">
                    <el-input v-model="form.demandNum" placeholder="请输入所需需求成交量"
                              onkeyup="value=value.replace(/[^\d]/g,'')" maxlength="4"></el-input>
                </el-form-item>
                <el-form-item label="图标" prop="levelIconUrl">
                    <div style="display: flex;" v-loading="thumbnailLoading" class="thumbnailClass20">
                        <el-upload
                            action="/service-center/upload/file/single"
                            :show-file-list="false"
                            :headers="headers"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload" class="thumbnailClass">
                            <div class="avatar" v-if="!form.levelIconUrl">
                                <i class="el-icon-plus"></i>
                            </div>
                            <div>
                                <el-image
                                    v-if="form.levelIconUrl"
                                    :src="form.levelIconUrl"
                                    class="thumbnailClass"
                                    style="border: solid 1px #ececec;background-color: #f9f9f9;"
                                    :preview-src-list="thumbnailList">
                                </el-image>
                            </div>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item class="submitButtonClass">
                    <el-button @click="submit">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>

</template>
<!--<script src="https://a1.alicdn.com/oss/uploads/2018/12/26/7bfddb60-08e8-11e9-9b04-53e73bb6408b.js"></script>-->
<script>
    import tinymce from '@/components/tinymce'
    import {
        saveLevel,
        findDesignerLevelById,
        getDuplicateName,
        designerLevelListByPage
    } from "../../../utils/interface";
    import {mapState} from "vuex";

    export default {
        name: "designerLevelDialog",
        data() {
            return {
                fileListUrl: [],
                dialogVisible: false,
                cascaderShow: false,
                loading: false,
                id: '',
                title: '',
                headers: {
                    'Authorization': 'Bearer ' + window.sessionStorage.getItem("api_access_token")
                },
                dialogFormVisible: false,
                form: {
                    // activityType: '',
                    name: '',
                    modelNum: '',
                    modelNum2: '',
                    demandNum: '',
                    levelIconUrl: '',
                    // commissionRate: '',
                    type: 'MODEL'
                },
                rules: {
                    name: [
                        {required: true, message: '请输入级别名称', trigger: 'blur'}
                    ],
                    modelNum: [
                        {required: true, message: '请输入所需模型数量', trigger: 'blur'}
                    ],
                    modelNum2: [
                        {required: true, message: '请输入所需作品数量', trigger: 'blur'}
                    ],
                    demandNum: [
                        {required: true, message: '请输入所需需求成交量', trigger: 'blur'}
                    ],
                    levelIconUrl: [
                        {required: true, message: '请上传对应图标'}
                    ],
                    // commissionRate: [
                    //     {required: true, message: '请输入佣金比例'}
                    // ],

                },
                typeOptions: [],
                processTypeList: [],
                thumbnailLoading: false,
                thumbnailLoading2: false,
                printScreenIndex: "0",
                thumbnailList: [],
                classShow: true,
                classShows: true,
                classShows2: true,
                thumbnailLists: [],
                screenList: [
                    {
                        name: "三维设计师",
                        screenTwo: [],
                    },
                    {
                        name: "平面设计师",
                        screenTwo: [],
                    },
                ],
                logisticsList: [],
                formSuccess: {
                    name: '',
                    number: '',
                    successName: '',
                    img: '',

                },
                thumbnailListForm: [],
                thumbnailLoading3: false,
                imgLists: [],

            }
        },
        components: {
            tinymce
        },
        methods: {
            init(type, uuid) {
                this.dialogVisible = true;
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.resetFields();
                }
                if (type === "add") {
                    this.title = "新增级别";
                    this.printScreenIndex = '0';
                    this.reset();
                } else {
                    this.reset();
                    this.title = "修改级别";
                    findDesignerLevelById({uuid: uuid}).then((res) => {
                        if (res.type == "MODEL") {
                            this.printScreenIndex = '0';
                        } else {
                            this.printScreenIndex = '1';
                        }
                        this.form = res;
                        if(this.form.type == "GRAPHIC"){//平面设计师
                            this.form.modelNum2 = this.form.modelNum;
                        }
                    });
                }

            },
            getPrintScreen(i) {
                this.checkedCities = [];
                if (this.printScreenIndex == i) {
                    this.classShow = !this.classShow;
                } else {
                    this.classShow = true;
                }
                this.printScreenIndex = i;
                if (i == 0) {
                    this.form.type = "MODEL";
                    this.classShows = false;
                    this.classShows2 = true
                } else if (i == 1) {
                    this.form.type = "GRAPHIC";
                    this.classShows = true;
                    this.classShows2 = false
                }
            },
            // logo上传
            handleAvatarSuccess2(res, file) {
                this.form.levelIconUrl.push(res.url)
                this.thumbnailLoading2 = false
                this.$refs.ruleForm.validateField('levelIconUrl')
            },
            beforeAvatarUpload2(file) {
                this.thumbnailLoading2 = true
                const isJPG = file.type.indexOf('image') !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.thumbnailLoading2 = false
                    this.$message.warning('上传图片只能是图片格式!');
                    this.thumbnailLoading2 = false
                }
                if (!isLt2M) {
                    this.thumbnailLoading2 = false
                    this.$message.warning('上传图片大小不能超过 2MB!');
                    this.thumbnailLoading2 = false
                }
                return isJPG && isLt2M;
            },
            // 缩略图上传
            handleAvatarSuccess(res, file) {
                this.form.levelIconUrl = res.url
                this.thumbnailLoading = false
                this.$refs.ruleForm.validateField('levelIconUrl')
            },
            beforeAvatarUpload(file) {
                this.thumbnailLoading = true
                const isJPG = file.type.indexOf('image') !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.thumbnailLoading = false
                    this.$message.warning('上传图片只能是图片格式!');
                    this.thumbnailLoading = false
                }
                if (!isLt2M) {
                    this.thumbnailLoading = false
                    this.$message.warning('上传图片大小不能超过 2MB!');
                    this.thumbnailLoading = false
                }
                return isJPG && isLt2M;
            },
            // 上传附件
            handleSuccessUrl(res, file) {
                this.form.workFormat = res.url
                this.$refs.ruleForm.validateField('workFormat')
            },
            // beforeUploadUrl(file) {
            //     const isJPG = file.type.indexOf('image') !== -1;
            //     const isLt2M = file.size / 1024 / 1024 < 2;
            //     if (!isJPG) {
            //         this.$message.warning('上传图片只能是图片格式!');
            //         this.thumbnailLoading = false
            //     }
            //     if (!isLt2M) {
            //         this.thumbnailLoading = false
            //         this.$message.warning('上传图片大小不能超过 2MB!');
            //         this.thumbnailLoading = false
            //     }
            //     return isJPG && isLt2M;
            // },
            // 大赛简介图片上船
            handleSuccessImgUrl(res, file) {
                this.form.workFormat = res.url
                this.$refs.ruleForm.validateField('workFormat')
            },
            beforeUploadImgUrl(file) {
                const isJPG = file.type.indexOf('image') !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.warning('上传图片只能是图片格式!');
                    this.thumbnailLoading = false
                }
                if (!isLt2M) {
                    this.thumbnailLoading = false
                    this.$message.warning('上传图片大小不能超过 2MB!');
                    this.thumbnailLoading = false
                }
                return isJPG && isLt2M;
            },
            // 大赛简介视频上传
            handleSuccessViodeUrl(res, file) {
                this.form.workFormat = res.url
                this.$refs.ruleForm.validateField('workFormat')
            },
            beforeUploadViodeUrl(file) {
                const isJPG = file.type.indexOf('mp4') !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.warning('上传视频!');
                    this.thumbnailLoading = false
                }
                if (!isLt2M) {
                    this.thumbnailLoading = false
                    this.$message.warning('上传视频大小不能超过 2MB!');
                    this.thumbnailLoading = false
                }
                return isJPG && isLt2M;
            },
            // 奖项配图
            handleAvatarSuccessUrl(res, file) {
                this.formSuccess.img = res.url
                this.thumbnailLoading3 = false
                this.$refs.ruleForm.validateField('img')
            },
            beforeAvatarUploadUrl(file) {
                this.thumbnailLoading3 = true
                const isJPG = file.type.indexOf('image') !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.thumbnailLoading3 = false
                    this.$message.warning('上传图片只能是图片格式!');
                    this.thumbnailLoading3 = false
                }
                if (!isLt2M) {
                    this.thumbnailLoading3 = false
                    this.$message.warning('上传图片大小不能超过 2MB!');
                    this.thumbnailLoading3 = false
                }
                return isJPG && isLt2M;
            },
            submit() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        // let reg=new RegExp("^(((\\d{1,2})[.]((\\d{1,2})?))|100|(?:0|[1-9][0-9]?)|100.00|100.0)$");
                        // if(!reg.test(this.form.commissionRate)){
                        //     this.$message.warning("佣金比例只能为0-100");
                        //     return false;
                        // }
                        let message = '';
                        if (this.form.uuid != null) {
                            message = '修改成功!';
                        } else {
                            message = '保存成功!';
                        }
                        getDuplicateName(this.form).then((res) => {
                            if (res.message == null && res.success == true) {
                                if(this.form.type == "GRAPHIC"){//平面设计师
                                    this.form.modelNum = this.form.modelNum2;
                                }
                                saveLevel(this.form).then((res) => {
                                    this.$message.success(message);
                                    this.dialogVisible = false;
                                    this.$parent.getList();
                                });
                            } else {
                                this.$message.warning("同类型设计师级别名称不能重复");
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            // 初始话重置表单
            reset() {
                this.form = {
                    name: '',
                    modelNum: '',
                    modelNum2: '',
                    demandNum: '',
                    levelIconUrl: '',
                    type: 'MODEL'
                    // commissionRate: ''
                }
                this.thumbnailLoading = false
            },
            // 新增作品类别
            addNext() {
                this.form.workCategoryList.push({
                    name: ''
                })
            },
            // 删除作品类别
            delNext(index) {
                this.form.workCategoryList.splice(index, 1)
            },
            // 新增奖项设置
            addAwardsNext() {
                // this.form.awardsSetting.push({
                //     name: ''
                // })

            },
            // 删除奖项设置
            delAwardsNext(index) {
                this.form.awardsSetting.splice(index, 1)
            },
            // 编辑器内容更新
            editHomepageInput(val) {
                this.$refs.ruleForm.validateField('homepage2')
            },
            // 编辑器内容更新
            editHomepageInput2(val) {
                this.$refs.ruleForm.validateField('homepage3')
            },
            editEntryGuideInput(val) {
                this.$refs.ruleForm.validateField('entryGuide')
            }
        }
    }
</script>

<style scoped lang="less">
        .typeItems{
            /deep/.el-form-item__content{
                margin-left: 0px!important;
            }
        }
    .dialogContent {
        padding: 0 5%;

        /deep/ .el-upload-list--picture-card .el-upload-list__item {
            width: 590px;
            height: 300px;
        }

        /deep/ .el-upload--picture-card {
            width: 590px;
            height: 300px;
            line-height: 300px;
        }

        /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
            width: 590px;
            height: 300px;
        }

        .titleTop {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 26px;
            margin-left: 48px;
        }

        .thumbnailClass {
            width: 150px;
            height: 150px;

            .avatar {
                width: 150px;
                height: 150px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 140px;
                font-size: 50px;
            }
        }

        .thumbnailClass2 {
            width: 222px;
            height: 125px;
            margin-left: 16px;
            margin-bottom: 5px;
        }

        .thumbnailClass20 {
            .avatar2 {
                width: 222px;
                height: 125px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 125px;
                font-size: 50px;
                margin-left: 16px;

                p {
                    margin: 0;
                    font-size: 16px;
                }
            }
        }

        .endPeriodClass {
            /deep/ .el-form-item__content {
                margin-left: 0 !important;
            }
        }

        .submitButtonClass {
            /deep/ .el-form-item__content {
                margin-left: 0 !important;
                text-align: center;

                button {
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 6px;
                }
            }
        }

        .modelHeightRangeClass {
            display: flex;
            margin-bottom: 25px;

            /deep/ .el-form-item__content {
                margin-left: 0 !important;
            }
        }
    }

    .successImgsUrl {
        cursor: pointer;
        color: #409EFF;
    }

    .print_screen_boxP {
        display: flex;
        flex-wrap: wrap;
        p {
            cursor: pointer;
            margin-bottom: 10px;
            margin-right: 0px;
            padding: 3px 14px;
            font-size: 14px;
        }

        .screen_text {
            color: #157efb;
            background: #157efb;
            border-radius: 5px;
            margin-bottom: 10px;
            color: #fff;
            padding: 3px 15px;
            font-size: 14px;
            cursor: pointer;
        }
    }

    .desTopClass {
        .typeName {
            font-size: 14px;
            width: 85px;
            letter-spacing: 23px;
        }

        .destoPone {
            p {
                margin-bottom: 10px;
                margin-right: 0px;
                padding: 3px 14px;
                font-size: 14px;
            }

            .materDetailsT {
                // background: #157efb;
                color: #157efb;
                border-radius: 5px;
                padding: 3px 15px;
                margin-bottom: 10px;
            }
        }

        .print_screen_boxP {
            display: flex;
            flex-wrap: wrap;

            p {
                cursor: pointer;
                margin-bottom: 10px;
                margin-right: 0px;
                padding: 3px 14px;
                font-size: 14px;
            }

            .screen_text {
                color: #157efb;
                background: #157efb;
                border-radius: 5px;
                margin-bottom: 10px;
                color: #fff;
                padding: 3px 15px;
                font-size: 14px;
                cursor: pointer;
            }
        }

        ul {
            display: flex;

            li {
                padding: 5px 12px;
                cursor: pointer;
                margin-right: 10px;

                &.active {
                    color: #fff;
                    background: #157efb;
                    border-radius: 4px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/designerLevelManager/designerLevelDialog/designerLevelDialog.vue